export { Input } from "@mantine/core";
export { getInputOverrides } from "./Input.styled";
